import Layout from './layout';
import { Heading, VStack } from '@chakra-ui/layout';
import Faq from "react-faq-component";

const data = {
    rows: [
        {
            title: "What is Eclair ?",
            content: "Eclair is the first ever 'Rewards' based NFT Marketplace built on CELO blockchain. We aim to make it easier for the community to collect and trade NFTs on CELO.",
        },
        {
            title: "How are rewards calculated ?",
            content: "Rewards are calculated on a complex algorithm taking in charge of users activity such as minting, trading NFTs.",
        },
        {
            title: "What fee does Eclair charge ?",
            content: "We charge 3% on a successful transaction, half of which goes back to users in the form of rewards.",
        },
        {
            title: "What are royalties ?",
            content: "Royalties are paid to the original creator of an NFT whenever it is traded between users. Creators are required to set royalties during minting. Once royalties are set they can’t be changed.",
        },
        {
            title: "Questions not answered ?",
            content: "Connect with us at our socials, we’ll be happy to help you out!",
        },      
    ],
};

const styles = {
    bgColor: '#19323C',
    titleTextColor: "#F2545B",
    titleTextSize: '40px',
    rowTitleColor: "white",
    rowTitleTextSize: '23px',
    rowContentColor: '#a8a8a8',
    rowContentTextSize: '20px',
    arrowColor: "white",
    rowContentPaddingTop: '10px',
    rowContentPaddingBottom: '10px',
    rowContentPaddingLeft: '10px',
    rowContentPaddingRight: '10px',
};

export default function faq() {

    return (
        <Layout>
            <VStack fontFamily='monospace' spacing='8'>
            <Heading fontFamily='monospace' fontSize='3xl'>Frequently Asked Questions</Heading>
            <Faq
                data={data}
                styles={styles}
            />
            </VStack>
        </Layout>
    );
}